import { acpSpendMoneyStates } from './states';

export default (appModule: ng.IModule) => {
  appModule.config(acpSpendMoneyStates);
};
